$(document).ready(async function () {
    const model = $(".calculator_container").data("model");
    let modelData = await $.getJSON(`/calculator/models/${model}`).then(data => data);
    $('.open_calculator').click(function () {
        $('#leasing_calc').css('display', 'block').animate({
            width: '100%'
        }, 400, function () {
            toCountHRV();
            toCountStandart();
        });

        let calculatorContainer = $('.calculator_container').outerHeight();
        if ($(window).width() > 992) {
            $('.bg_desk_black').css('min-height', calculatorContainer + 'px');
        }
        if ($(window).width() < 1199 && $(window).width() > 991) {
            $('.bg_desk_black').css('min-height', calculatorContainer + 50 + 'px');
        }
        if ($(window).width() < 991) {
            $('html, body').animate({
                scrollTop: 0
            }, 300);
        }
    });

    $('.close_calculator').click(function (event) {
        $('#leasing_calc').animate({
            width: '0'
        }, 400, function () {
            $(this).css('display', 'none');
        });
    });

    var changeCalc = $('.change_calculate .btn_change_calc');

    changeCalc.click(function (event) {
        $('.btn_change_calc').removeClass('active');
        $(this).addClass('active');
        if (changeCalc.hasClass('active')) {
            $('.calculator').removeClass('open')
            $('#' + $(this).attr('rel')).addClass('open');
        }
        toCountHRV();
        toCountStandart();
        toCountCredit();
        toCountLoan();
    });

    function getMonthlyPaymentCredit(result, rateResult, table, months, downPayment) {
        let cell = table[months][downPayment];
        result.text(cell['price']);
        rateResult.text(cell['rrso']);
    }

    function getMonthlyPayment(result, table, months, downPayment) {
        let monthlyPayment = table[months][downPayment];
        result.text(monthlyPayment);
    }

    /**
     * Baicowy leasing
     */
    function toCountHRV() {
        if ($('#calculateRateHRV').hasClass('open')) {
            var result = $('#monthlyPaymentHRV');
            var leasingHRVTable = modelData['baic_leasing'];

            $('#monthsHRV').on('input', function () {
                $('#monthsHRVValue').text($(this).val());
                getMonthlyPayment(result, leasingHRVTable, $('#monthsHRV').val(), $('#downPaymentHRV').val());
                const monthsValue = $('#monthsHRV').val();
                $('#kmLimitHRVValue').text(leasingHRVTable[monthsValue]['mileage']+" km");
                $('#priceGap').text(leasingHRVTable[monthsValue]['gap']);
                $('#baicLeasingBuyOut').text(leasingHRVTable[monthsValue]['buyout']+"%");
            });

            $('#downPaymentHRV').on('input', function () {
                $('#downPaymentHRVValue').text($(this).val() + '%');
                getMonthlyPayment(result, leasingHRVTable, $('#monthsHRV').val(), $('#downPaymentHRV').val());
            });
            getMonthlyPayment(result, leasingHRVTable, $('#monthsHRV').val(), $('#downPaymentHRV').val());
        }
    }

    /**
     * Leasing standard
     */
    function toCountStandart() {
        if ($('#calculateRateStandart').hasClass('open')) {
            var result = $('#monthlyPaymentStandart');
            var leasingStandartTable = modelData['standard_leasing'];

            $('#monthsStandart').on('input', function () {
                $('#monthsStandartValue').text($(this).val());
                getMonthlyPayment(result, leasingStandartTable, $('#monthsStandart').val(), $('#downPaymentStandart').val());

                const monthsValue = $('#monthsStandart').val();
                $('#buyOut').text(leasingStandartTable[monthsValue]['buyout']+"%");
                $('#priceGapStandart').text(leasingStandartTable[monthsValue]['gap']);
            });

            $('#downPaymentStandart').on('input', function () {
                $('#downPaymentStandartValue').text($(this).val() + '%');
                getMonthlyPayment(result, leasingStandartTable, $('#monthsStandart').val(), $('#downPaymentStandart').val());
            });
            getMonthlyPayment(result, leasingStandartTable, $('#monthsStandart').val(), $('#downPaymentStandart').val());
        }
    }

    /**
     * Baicowa pożyczka
     */
    function toCountCredit() {
        if ($('#calculateRateCredit').hasClass('open')) {
            var result = $('#monthlyPaymentCredit');
            var rateResult = $('#monthlyRRSOCredit');

            var CreditTable = modelData['baic_credit'];

            $('#monthsCredit').on('input', function () {
                $('#monthsCreditValue').text($(this).val());
                getMonthlyPaymentCredit(result, rateResult, CreditTable, $('#monthsCredit').val(), $('#downPaymentCredit').val());

                const monthsValue = $('#monthsCredit').val();
                $('#priceGapCredit').text(CreditTable[monthsValue]['gap']);
            });
            $('#downPaymentCredit').on('input', function () {
                $('#downPaymentCreditValue').text($(this).val() + '%');
                getMonthlyPaymentCredit(result, rateResult, CreditTable, $('#monthsCredit').val(), $('#downPaymentCredit').val());
            });
            getMonthlyPaymentCredit(result, rateResult, CreditTable, $('#monthsCredit').val(), $('#downPaymentCredit').val());
        }
    }

    /**
     * Pożyczka
     */
    function toCountLoan() {
        if ($('#calculateRateLoan').hasClass('open')) {
            var result = $('#monthlyPaymentLoan');
            var rateResult = $('#monthlyRRSOLoan');
            var LoanTable = modelData['standard_credit'];

            $('#monthsLoan').on('input', function () {
                $('#monthsLoanValue').text($(this).val());
                getMonthlyPaymentCredit(result, rateResult, LoanTable, $('#monthsLoan').val(), $('#downPaymentLoan').val());

                const monthsValue = $('#monthsLoan').val();
                $('#priceGapLoan').text(LoanTable[monthsValue]['gap']);
            });
            $('#downPaymentLoan').on('input', function () {
                $('#downPaymentLoanValue').text($(this).val() + '%');
                getMonthlyPaymentCredit(result, rateResult, LoanTable, $('#monthsLoan').val(), $('#downPaymentLoan').val());
            });
            getMonthlyPaymentCredit(result, rateResult, LoanTable, $('#monthsLoan').val(), $('#downPaymentLoan').val());
        }
    }

});
